import axios from "axios";
import client, {
  setAccessToken,
  setRefreshToken,
  clearTokens,
  resolveBaseUrl,
} from "./client";

const BASE_URL = resolveBaseUrl();

export const loginWithGoogle = async (credential) => {
  const {data} = await axios.post(`${BASE_URL}/auth/google/`, {credential});
  setAccessToken(data.access);
  setRefreshToken(data.refresh);
  return data.user;
};

export const getMe = async () => {
  const {data} = await client.get("/auth/me/");
  return data;
};

export const getCreditHistory = async (page = 1, pageSize = 20) => {
  const {data} = await client.get("/auth/credit-history/", {
    params: {
      page,
      page_size: pageSize,
    },
  });
  return data;
};

export const getPricingCatalog = async () => {
  const {data} = await client.get("/auth/pricing/");
  return data;
};

export const getLandingConfig = async (app = "fet") => {
  const {data} = await client.get("/auth/landing-config/", {
    params: { app },
  });
  return data;
};

export const getPromotionAdmin = async () => {
  const {data} = await client.get("/auth/promotion-admin/");
  return data;
};

export const getLandingAdmin = async () => {
  const {data} = await client.get("/auth/landing-admin/");
  return data;
};

export const savePromotionAdmin = async (payload) => {
  const {data} = await client.put("/auth/promotion-admin/", payload);
  return data;
};

export const saveLandingAdmin = async (payload) => {
  const {data} = await client.put("/auth/landing-admin/", payload);
  return data;
};

export const createCheckoutSession = async (
  productKey,
  returnTo = "",
  frontendBaseUrl = "",
) => {
  const {data} = await client.post("/auth/checkout/", {
    product_key: productKey,
    return_to: returnTo,
    frontend_base_url: frontendBaseUrl,
  });
  return data;
};

export const confirmCheckoutSession = async (sessionId) => {
  const {data} = await client.post("/auth/checkout/confirm/", {
    session_id: sessionId,
  });
  return data;
};

export const claimFreeCredits = async () => {
  const {data} = await client.post("/auth/free-credits/claim/");
  return data;
};

export const logout = () => {
  clearTokens();
};
